import * as React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
} from 'react-admin';
import { products, scenarios, priceUnits } from '../../utils/choices';

export const ProductCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="id" validate={[required()]} />
      <TextInput
        disabled
        source="purchaseType"
        validate={[required()]}
        defaultValue="consumable"
      />
      <SelectInput
        source="type"
        choices={products}
        optionText="id"
        optionValue="id"
        validate={[required()]}
      />
      <SelectInput
        source="scenario"
        choices={scenarios}
        optionText="id"
        optionValue="id"
        validate={[required()]}
      />
      <SelectInput
        source="priceUnit"
        choices={priceUnits}
        optionText="id"
        optionValue="id"
        validate={[required()]}
      />
      <TextInput source="price" />
      <TextInput source="num" />
      <TextInput source="description" />
    </SimpleForm>
  </Create>
);
